import * as React from 'react';
import { Container } from 'reactstrap';
import './About.css';
import Col from "reactstrap/lib/Col";
import Row from "reactstrap/lib/Row";
import * as Scroll from 'react-scroll';

export class About extends React.Component<any,{}> {

  render() {
    return (
      <section className="page-section" id="about-section">
        <Scroll.Element name="about">
          <Container tag="article">
            <header className="section-header">
              <Row>
                <Col xs="12">
                  <h1>Mitä teemme?</h1>
                </Col>
              </Row>
            </header>
            <Row>
              <Col xs="12" md="4" className="wow fadeInUp">
                <img src={require("../../assets/images/icons/icons-01.png")} alt="Digipalvelut" className="column-image" />
                  <h3>Käyttäjälähtöinen suunnittelu</h3>
                  <p>Suunnittelemme digitaalisia palveluita, joita on mukava käyttää. Teemme mieluiten töitä läheisessä yhteistyössä asiakasyrityksen ja loppukäyttäjien kanssa.</p>
              </Col>
              <Col xs="12" md="4"  className="wow fadeInUp" data-wow-delay="0.1s">
                <img src={require("../../assets/images/icons/icons-02.png")} alt="Käyttäjäkokemukset" className="column-image" />
                  <h3>Palveluiden toteuttaminen</h3>
                  <p>Interaktiivisista prototyypeistä valmiiksi palveluiksi. Työkaluina mm. React, Angular, Node, PHP, Apache Cordova, Phonegap, Wordpress ja Woocommerce.</p>
              </Col>
              <Col xs="12" md="4"  className="wow fadeInUp" data-wow-delay="0.1s">
                <img src={require("../../assets/images/icons/icons-03.png")} alt="Tiedon visualisointi" className="column-image" />
                <h3>Ilme ja tiedon visualisointi</h3>
                <p>Suunnittelemme visuaaliset identiteetit yrityksille ja palveluille sekä visualisoimme informaatiota selkeään, kauniseen ja vaikuttavaan muotoon.</p>
              </Col>
            </Row>
          </Container>
        </Scroll.Element>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/about/About.tsx